import React from "react"
import { useBooking } from "./useBooking"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import Loader from "../../../../../components/ui/loader"
import UserLink from "../../../../../components/v2/utils/UserLink"
import MeetDateTimeFromUtc from "../../../../../components/v2/utils/MeetDateTimeFromUtc"
import Button from "@material-ui/core/Button/Button"

const AppointmentBookingDialog = ({ activeBookingId, open, onClose }) => {
  const { booking, isSuccess } = useBooking(activeBookingId)

  const onAccept = () => {}
  const onDecline = () => {}

  return (
    <Dialog
      aria-labelledby="create-record-dialog"
      onClose={onClose}
      open={open}
    >
      <DialogTitle id="alert-dialog-title" className="text-center">
        Appointment booking details
      </DialogTitle>
      <DialogContent>
        {isSuccess ? (
          <div className="f jcc full-width">
            <table className="product-details product-details--invenstory-record">
              <tbody>
                <tr className="product-details__row">
                  <td className="product-details__label">Name</td>
                  <td className="product-details__value">{booking.title}</td>
                </tr>

                {booking.b_creator ? (
                  <tr className="product-details__row">
                    <td className="product-details__label">Invitee</td>
                    <td className="product-details__value">
                      <div>
                        <div className={"mb10"}>
                          {booking.invitee_id ? (
                            <UserLink
                              user={{
                                id: booking.invitee_id,
                                first_name: booking.invitee_name_first,
                                last_name: booking.invitee_name_last,
                              }}
                            />
                          ) : (
                            <span>
                              {booking.invitee_name_first}{" "}
                              {booking.invitee_name_last}
                            </span>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="product-details__row">
                    <td className="product-details__label">Inviter</td>
                    <td className="product-details__value">
                      <div>
                        <div className={"mb10"}>
                          {booking.creator_id ? (
                            <UserLink
                              user={{
                                id: booking.creator_id,
                                first_name: booking.creator_name_first,
                                last_name: booking.creator_name_last,
                              }}
                            />
                          ) : (
                            <span>
                              {booking.creator_name_first}{" "}
                              {booking.creator_name_last}
                            </span>
                          )}
                        </div>
                        <div className={"mb10"}>
                          <span>Email: </span>
                          <a
                            href={`mailto:${booking.creator_email}`}
                            className={"link link--inline"}
                          >
                            {booking.creator_email}
                          </a>
                        </div>
                        <div>
                          <span>Phone: </span>
                          <a
                            href={`tel:${booking.creator_phone}`}
                            className={"link link--inline"}
                          >
                            {booking.creator_phone}
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                <tr className="product-details__row">
                  <td className="product-details__label">Date and time</td>
                  <td className="product-details__value">
                    <div>
                      <div className={"mb10"}>
                        <p>For you:</p>
                        <MeetDateTimeFromUtc
                          date={booking.date_from}
                          duration={Number(booking.duration)}
                          activeTimezone={
                            Intl.DateTimeFormat().resolvedOptions().timeZone
                          }
                        />
                      </div>
                      <div>
                        <p>For {booking.creator_name_first}:</p>
                        <MeetDateTimeFromUtc
                          date={booking.date_from}
                          duration={Number(booking.duration)}
                          activeTimezone={booking.time_zone}
                        />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr className="product-details__row">
                  <td className="product-details__label">Appointment type</td>
                  <td className="product-details__value">
                    {booking.duration} min
                  </td>
                </tr>

                <tr className="product-details__row">
                  <td className="product-details__label">Conference link</td>
                  <td className="product-details__value">
                    <a href={booking.conference_link} className={"link"}>
                      {booking.conference_link}
                    </a>
                  </td>
                </tr>

                {!!booking.location && (
                  <tr className="product-details__row">
                    <td className="product-details__label">Location</td>
                    <td className="product-details__value">
                      {booking.location}
                    </td>
                  </tr>
                )}

                {!!booking.details && (
                  <tr className="product-details__row">
                    <td className="product-details__label">Details</td>
                    <td className="product-details__value">
                      {booking.details}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <Loader />
        )}
      </DialogContent>
      <DialogActions>
        <div className="f jcsb full-width">
          <div>
            {isSuccess &&
              !booking.b_creator &&
              !(booking?.is_accepted || booking?.is_declined) && (
                <>
                  <Button color="primary" onClick={onAccept}>
                    Accept
                  </Button>
                  <Button color="primary" onClick={onDecline}>
                    Decline
                  </Button>
                </>
              )}
          </div>
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default AppointmentBookingDialog
